import Link from "next/link";
import React from "react";
import FooterLogo from "../../../public/assets/img/logo/logo-2.png";
import Image from "next/image";
import CopyrightArea from "./copyright-area";

const MemoAuthFooter = () => {
  return (
    <>
      <footer>
        <div className="footer__area footer-bg">
          <div className="footer__top pt-10 pb-10"></div>
          <CopyrightArea />
        </div>
      </footer>
    </>
  );
};

export default MemoAuthFooter;
